import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import PremiumBenefits from '../pages/GuildDashboard/components/PremiumBenefits'
import { SubscriptionTier } from 'app/frontend/types/custom'
import { PropsWithChildren } from 'react'

interface Props {
  tierName: SubscriptionTier
}

const PremiumBenefitsPreviewModal = ({
  tierName,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className={'max-w-5xl'}>
        <DialogHeader>
          <DialogTitle>Boost preview</DialogTitle>
        </DialogHeader>

        <PremiumBenefits benefits={[]} previewingTier={tierName} />

        <DialogFooter>
          <DialogClose asChild>
            <Button type='button' variant='secondary'>
              Close
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PremiumBenefitsPreviewModal
